import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { graphql } from "@commerce-frontend/types";
import type { ResultOf } from "@graphql-typed-document-node/core";
import { type HTMLAttributes, forwardRef } from "react";
import { NewsletterForm } from "../../../app/[locale]/(regular-layout)/_components/NewsletterForm/NewsletterForm";

export const NewsletterCTAFragment = graphql(/* GraphQL */ `
	fragment NewsletterCTAFragment on NewsletterCTA {
		__typename
		id
		orientation
	}
`);

export type NewsletterCTAProps = {
	data: ResultOf<typeof NewsletterCTAFragment>;
} & HTMLAttributes<HTMLDivElement>;

export const NewsletterCTA = forwardRef<HTMLDivElement, NewsletterCTAProps>(
	({ data, ...props }, ref) => {
		return (
			<NewsletterForm
				{...props}
				orientation={data.orientation}
				{...storyblokDataAttributes(data)}
				ref={ref}
			/>
		);
	},
);

NewsletterCTA.displayName = "NewsletterCTA";
